export default function OrgSection() {
  return (
    <section
      id="org"
      className={`w-full md:min-h-screen flex items-center py-7 relative`}
    >
      <div className="myContainer w-full flex max-md:flex-col">
        {/* Absolute md background */}
        <svg
          className={`absolute left-0 bottom-0 w-dvw !z-0 max-md:hidden`}
          xmlns="http://www.w3.org/2000/svg"
          width="1440"
          height="869"
          viewBox="0 0 1440 869"
          fill="none"
        >
          <path
            d="M-571.885 -264.024C-891.281 -546.306 -747.075 756.409 -408.32 827.889C148.844 945.455 143.392 881.677 506.601 881.677C899.549 881.677 1649.21 1010.11 1637.87 664.217C1631.11 457.896 1228.52 457.789 973.838 533.587C769.87 594.292 818.744 486.714 513.77 465.198C202.785 443.259 64.0137 233.208 -221.296 77.1245C-420.702 -31.9641 -450.546 -156.784 -571.885 -264.024Z"
            fill="#F3F5FA"
          />
        </svg>
        <div className={`w-full md:w-1/2 z-10`}>
          <img src="/img/home/two phone mockUp1.png" alt="Two Phone MockUp" />
        </div>
        <div
          className={`w-full md:w-1/2 md:max-w-[500px] flex flex-col justify-center z-10 *:z-10 max-md:mt-10`}
        >
          <span className={`text-[#232323] font-black text-2xl lg:text-6xl`}>
            پلتفرم سازمانی <strong className={`text-myBlue`}>G&G</strong>
          </span>
          <span
            className={`text-[#518EF8] text-xl md:text-3xl w-full text-center mt-1`}
          >
            بهبود بهره‌وری سازمانــــی با بازی و پاداش
          </span>
          <div
            className={`w-full flex max-md:flex-col justify-between items-center gap-2 mt-10`}
          >
            <a
              href="https://org.gameandgrow.com/"
              className={`w-full md:w-[calc(50%-4px)]`}
            >
              <button className="btn rounded-xl border border-myBlue w-full bg-white text-myBlue font-normal">
                ورود به پنل سازمــــانی
              </button>
            </a>
            <a
              href="#downloadSection"
              className={`w-full md:w-[calc(50%-4px)]`}
            >
              <button className="btn rounded-xl border border-myBlue w-full bg-myBlue text-white font-normal">
                دانلود اپلیکیشن سازمانی
                <img src="/img/home/Cafebazaar-Logo.png" alt="Bazaar Logo" />
              </button>
            </a>
          </div>

          <div
            className={`w-full flex items-center justify-center max-md:hidden`}
          >
            <img
              className={`max-w-[50%]`}
              src="/img/home/Group 21.png"
              alt="Grouped Img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
